export default {
  "b2b.doplnkove-sluzby-grid.id.label": "Id",
  "b2b.doplnkove-sluzby-grid.nazev.label": "Název",
  "b2b.doplnkove-sluzby-grid.popis.label": "Popis",
  "b2b.doplnkove-sluzby-grid.zkratka.label": "zkratka",
  "b2b.doplnkove-sluzby-grid.uzivaNapajeni.label": "Užívá napájení",
  "b2b.doplnkove-sluzby-grid.vylucny.label": "Výlučný"
};
